import React from 'react';

export interface IClientErrorContextProps {
    nameNotDefinedError: boolean,
    setNameNotDefinedError: (error: boolean) => void,
    productNotSelectedError: boolean,
    setProductNotSelectedError: (error: boolean) => void,
    vehicleNotDefinedError: boolean,
    setVehicleNotDefinedError: (error: boolean) => void,
    keywordsNotDefinedError: boolean,
    setKeywordsNotDefinedError: (error: boolean) => void,
    sourceNotDefinedError: boolean,
    setSourceNotDefinedError: (error: boolean) => void,
    extraParameterNotDefinedError: boolean,
    setExtraParameterNotDefinedError: (error: boolean) => void,
    contentNotDefinedError: boolean,
    setContentNotDefinedError: (error: boolean) => void,
    avatarFileError: boolean,
    setAvatarFileError: (error: boolean) => void,
    primaryColorNotDefinedError: boolean,
    setPrimaryColorNotDefinedError: (error: boolean) => void,
    secondaryColorNotDefinedError: boolean,
    setSecondaryColorNotDefinedError: (error: boolean) => void,
    primaryColorError: boolean,
    setPrimaryColorError: (error: boolean) => void,
    secondaryColorError: boolean,
    setSecondaryColorError: (error: boolean) => void,
    organogramNotSelectedInCutoutError: boolean,
    setOrganogramNotSelectedInCutoutError: (error: boolean) => void,
}

export const ClientErrorContextInitial: IClientErrorContextProps = {
    nameNotDefinedError: false,
    setNameNotDefinedError: () => { ''; },
    productNotSelectedError: false,
    setProductNotSelectedError: () => { ''; },
    vehicleNotDefinedError: false,
    setVehicleNotDefinedError: () => { ''; },
    keywordsNotDefinedError: false,
    setKeywordsNotDefinedError: () => { ''; },
    sourceNotDefinedError: false,
    setSourceNotDefinedError: () => { ''; },
    extraParameterNotDefinedError: false,
    setExtraParameterNotDefinedError: () => { ''; },
    contentNotDefinedError: false,
    setContentNotDefinedError: () => { ''; },
    avatarFileError: false,
    setAvatarFileError: () => { ''; },
    primaryColorNotDefinedError: false,
    setPrimaryColorNotDefinedError: () => { ''; },
    secondaryColorNotDefinedError: false,
    setSecondaryColorNotDefinedError: () => { ''; },
    primaryColorError: false,
    setPrimaryColorError: () => { ''; },
    secondaryColorError: false,
    setSecondaryColorError: () => { ''; },
    organogramNotSelectedInCutoutError: false,
    setOrganogramNotSelectedInCutoutError: () => { ''; },
};

export const ClientErrorContext = React.createContext(ClientErrorContextInitial);